import { createContext, useContext, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const SeatMapModalContext = /*#__PURE__*/createContext(null);
const SeatMapModalProvider = ({
  children
}) => {
  const [isSeatMapModalOpen, setIsSeatMapModalOpen] = useState(false);
  const [seatMapCallback, setSeatMapCallback] = useState(() => () => {});
  return /*#__PURE__*/_jsx(SeatMapModalContext.Provider, {
    value: {
      isSeatMapModalOpen,
      setIsSeatMapModalOpen,
      seatMapCallback,
      setSeatMapCallback
    },
    children: children
  });
};
export const useSeatMapModal = () => {
  const context = useContext(SeatMapModalContext);
  if (!context) {
    throw new Error('useSeatMapModal must be used within a SeatMapModalProvider');
  }
  return context;
};
export default SeatMapModalProvider;
//# sourceMappingURL=SeatMapModalContext.js.map